import { Box, Typography, Grid, Select, Option, Divider } from "@mui/joy";
import { Sheet, Square } from "lucide-react";
import { Controller, useFormContext } from "react-hook-form";
import { FormInput, FormSelect, FormActionSelect } from "../../../shared";
import React from "react";
import { BorderRight } from "@mui/icons-material";

export function UnderlaymentAndShield({ loading }: { loading?: boolean }) {
    const { control } = useFormContext();

    return (
        <Box
        >
            <Box mb={2}>
                <Typography level="title-md">Underlayment & Shield</Typography>
                <Typography level="body-sm" color="neutral">
                    Specify the underlayment type and ice/water barrier details.
                </Typography>
            </Box>

            <Box
                sx={{
                    p: 2,
                    borderRadius: "4px",
                    border: "1px solid",
                    borderColor: "rgba(128, 128, 128, 0.2)",
                    bgcolor: "rgba(128, 128, 128, 0.05)",
                    backdropFilter: "blur(12px)",
                }}
            >
                <Grid container spacing={2.5}>
                    <Grid xs={12} sm={12} md={6} lg={6}>
                        <FormSelect
                            name="UnderlaymentType"
                            label="Underlayment Type"
                            placeholder="Select type"
                            helperText="Material used under shingles."
                            disabled={loading}
                            startDecorator={<Sheet size={16} />}
                            options={["Felt 15 lb", "Synthetic"]}
                        />
                    </Grid>

                    <Grid xs={12} sm={12} md={6} lg={6}>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 0.5,
                            }}
                        >
                            <Typography
                                level="body-xs"
                                sx={{
                                    textTransform: "uppercase",
                                    fontWeight: "xl",
                                    letterSpacing: "0.5px",
                                }}
                            >
                                Ice & Water Barrier
                            </Typography>
                            <Typography
                                level="body-xs"
                                color="neutral"
                                sx={{ mt: -0.5, mb: 0.5, fontSize: "12px" }}
                            >
                                Quantity in square feet and action.
                            </Typography>
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: 0,
                                    alignItems: "flex-start",
                                }}
                            >
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                    <FormInput
                                        name="IceWaterBarrierSQ"
                                        type="number"
                                        placeholder="0"
                                        sx={{
                                            borderTopRightRadius: 0,
                                            borderBottomRightRadius: 0,
                                            BorderRight: 0,
                                            minWidth: 0,
                                        }}
                                        disabled={loading}
                                        startDecorator={<Square size={16} />}
                                        endDecorator={
                                            <Typography
                                                level="body-xs"
                                                sx={{
                                                    color: "text.tertiary",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                SF
                                            </Typography>
                                        }
                                    />
                                </Box>
                                <Box sx={{ width: 100, flexShrink: 0 }}>
                                    <FormActionSelect
                                        name="IceWaterBarrierAction"
                                        disabled={loading}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
